import styled from 'styled-components';
import {
  SavedQueriesItem,
  SavedQueriesList,
} from '@/features/savedQueriesWidget/styled-components';

export const GeneralStylesWidgetContainer = styled.div`
  --border-radius: 4px;

  margin-bottom: 23px;

  ${SavedQueriesList} {
    border: 1px solid #ccc;
    border-radius: var(--border-radius);
  }

  ${SavedQueriesItem}:first-child {
    border-top-left-radius: var(--border-radius);
    border-top-right-radius: var(--border-radius);
  }

  ${SavedQueriesItem}:last-of-type {
    border-bottom-left-radius: var(--border-radius);
    border-bottom-right-radius: var(--border-radius);
  }
`;
